import { MutableRefObject } from 'react';
import * as THREE from 'three';
import { useModelRotation } from '../hooks/use-model-rotation';

type Props = {
  target: MutableRefObject<THREE.Group | null>;
  isPlaying: boolean;
};

export function RotationController({ target, isPlaying }: Props) {
  useModelRotation(target, isPlaying, 0.8);

  return null;
}
